import React from 'react';

const Contacts = () => (
  <div className="contacts">
    <div className="title">Contacts</div>
    <div className="content">
      <ul>
        <li>
          Direction Relation Partenaires (DRP)<br/>
          0 800 347 347<br/>
          <div className="commercial">
            Pour les équipes commerciales&nbsp;:<br/>
            <em>Support opérationnel</em>&nbsp;: 01 69 64 44 60<br/>
            <em>Support commercial</em>&nbsp;: 01 69 64 44 90<br/>
          </div>
        </li>
        <li>
          Service client<br/>
          09 77 40 39 71
        </li>
        <li>
          Si vous avez des remarques ou des suggestions&nbsp;:{' '}
          <a href="mailto:info.reseau@pmu.fr?subject=Book de visite">contactez-nous</a>
        </li>
      </ul>
    </div>
  </div>
);

export default Contacts;



// WEBPACK FOOTER //
// ./book/src/commons/components/contacts/Contacts.jsx